import React from "react";
import { TrendingUp, Users, Clock, CheckCircle2 } from "lucide-react";

const STORIES = [
  {
    icon: TrendingUp,
    metric: "42 hires",
    metricLabel: "in 9 weeks",
    title: "Scaling a Pune SaaS Engineering Team",
    text: "Built a full-stack engineering pipeline across React, Node, Data and DevOps — closed 42 mid-to-senior roles in nine weeks with an 82% offer-acceptance rate.",
    tags: ["IT Recruitment", "Bulk Hiring"],
  },
  {
    icon: Users,
    metric: "3 leaders",
    metricLabel: "hired confidentially",
    title: "Executive Search for a FinTech Client",
    text: "Discreet leadership hiring for a Series-B FinTech — VP Engineering, Head of Product and CFO placed inside a 12-week retained engagement.",
    tags: ["Executive Search", "Confidential"],
  },
  {
    icon: Clock,
    metric: "5 days",
    metricLabel: "avg. shortlist",
    title: "Non-IT Volume Hiring for a BPO",
    text: "Coordinated 220+ customer support hires across three centres with a five-day average shortlist turnaround and integrated background verification.",
    tags: ["Bulk Hiring", "BPO"],
  },
  {
    icon: CheckCircle2,
    metric: "96%",
    metricLabel: "6-month retention",
    title: "Campus-to-Corporate Program",
    text: "Ran a structured campus drive across four engineering colleges — 68 offers with 96% still with the client after six months of joining.",
    tags: ["Campus Hiring", "Assessment"],
  },
];

const IMAGES = [
  "https://images.unsplash.com/photo-1573497620053-ea5300f94f21?auto=format&fit=crop&w=800&q=80",
  "https://images.pexels.com/photos/7580644/pexels-photo-7580644.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.pexels.com/photos/7580640/pexels-photo-7580640.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.pexels.com/photos/7644081/pexels-photo-7644081.jpeg?auto=compress&cs=tinysrgb&w=800",
];

export default function SuccessStories() {
  return (
    <section className="section-pad bg-white">
      <div className="container-brand">
        <div className="max-w-3xl">
          <span className="eyebrow">Success Stories</span>
          <h2 className="mt-3 heading-2">Real Outcomes. Real Teams. Real Impact.</h2>
          <p className="mt-4 body-lg">
            A snapshot of illustrative mandates that reflect how we operate —
            structured, transparent and outcome-focused across IT, Non-IT and
            leadership hiring.
          </p>
        </div>
        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {STORIES.map((s, i) => (
            <div key={s.title} className="group card-surface overflow-hidden hover:-translate-y-1 transition-transform">
              <div className="relative h-48 overflow-hidden">
                <img
                  src={IMAGES[i % IMAGES.length]}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/70 via-brand-navy/10 to-transparent" />
                <div className="absolute bottom-4 left-5 flex items-center gap-2 text-white">
                  <div className="p-2 rounded-lg bg-brand-teal">
                    <s.icon className="h-4 w-4" />
                  </div>
                  <div className="text-white">
                    <div className="font-heading font-extrabold text-xl leading-none">{s.metric}</div>
                    <div className="text-[11px] uppercase tracking-widest opacity-90">{s.metricLabel}</div>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-heading font-bold text-brand-navy text-lg">{s.title}</h3>
                <p className="mt-2 text-sm text-brand-textSoft leading-relaxed">{s.text}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {s.tags.map((t) => (
                    <span key={t} className="chip">{t}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-8 text-xs text-brand-textSoft italic">
          Numbers shown are representative outcomes across recent engagements.
          Every mandate is quoted realistically — timelines depend on role, band and location.
        </p>
      </div>
    </section>
  );
}
